import mixpanel from './mixpanel'
import { env } from '@/config/env'

// Analytics service interface
interface AnalyticsService {
  readonly isEnabled: boolean
  track(event: string, properties?: Record<string, any>): void
  identify(userId: string, properties?: Record<string, any>): void
  setUserProperties(properties: Record<string, any>): void
  optIn(): void
  optOut(): void
  reset(): void
}

// Mixpanel implementation
class MixpanelService implements AnalyticsService {
  public readonly isEnabled: boolean

  constructor() {
    // Only enable analytics in production
    this.isEnabled = env.isProduction && !!env.mixpanelToken
  }

  track(event: string, properties?: Record<string, any>): void {
    if (!this.isEnabled) return

    try {
      mixpanel.track(event, properties)
    } catch (error) {
      console.warn('Analytics tracking failed:', error)
    }
  }

  identify(userId: string, properties?: Record<string, any>): void {
    if (!this.isEnabled) return

    try {
      mixpanel.identify(userId)
      if (properties) {
        mixpanel.people.set(properties)
      }
    } catch (error) {
      console.warn('Analytics identification failed:', error)
    }
  }

  setUserProperties(properties: Record<string, any>): void {
    if (!this.isEnabled) return

    try {
      mixpanel.people.set(properties)
    } catch (error) {
      console.warn('Analytics user properties failed:', error)
    }
  }

  optIn(): void {
    if (!this.isEnabled) return

    try {
      mixpanel.opt_in_tracking()
    } catch (error) {
      console.warn('Analytics opt-in failed:', error)
    }
  }

  optOut(): void {
    if (!this.isEnabled) return

    try {
      mixpanel.opt_out_tracking()
    } catch (error) {
      console.warn('Analytics opt-out failed:', error)
    }
  }

  reset(): void {
    if (!this.isEnabled) return

    try {
      this.optOut()
      mixpanel.reset()
    } catch (error) {
      console.warn('Analytics reset failed:', error)
    }
  }
}

// Main analytics instance
const analytics = new MixpanelService()

export default analytics
